import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteForm } from 'store/data/forms';

export function useDeleteForm(): Operation<(formId: string) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.DELETE_FORM);

	async function handler(formId: string) {
		if (loading) return;
		if (error) resetError();

		await dispatch(deleteForm(formId));
	}

	return [{ loading, error }, handler];
}
